import { cn } from '~/lib/utils'

export const Title = ({
  children,
  className,
  subtitle,
}: {
  children: React.ReactNode
  className?: string
  subtitle?: string
}) => {
  if (subtitle) {
    return (
      <div className={cn('flex flex-col', className)}>
        <TitleComponent>{children}</TitleComponent>
        <span className="text-base text-muted-foreground capitalize">{subtitle}</span>
      </div>
    )
  }

  return <TitleComponent className={className}>{children}</TitleComponent>
}

function TitleComponent({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <h1 className={cn('text-4xl font-bold font-brand', className)}>{children}</h1>
}
